<div
  class="error-pages-container d-flex align-items-center justify-content-center flex-column"
  data-cy="error-page-too-small-container"
  *transloco="let err; read: 'errors.screenNotSupported'">
  <cx-message class="message-no-height">
    <cx-message-image [imageSrc]="'assets/images/small-screen.svg'" />
    <cx-message-title>{{ err('title') }}</cx-message-title>
    <cx-message-text>
      <div class="text-center">
        {{ err('description') }}
      </div>
    </cx-message-text>
  </cx-message>
</div>
